export const LOGO_SRC = "/assets/logo-kb.webp";

export const Logo = ({ size = 44, className = "", priority = false, testId = "brand-logo" }) => (
  <img
    src={LOGO_SRC}
    alt="KINGBULLISH logo"
    width={size}
    height={size}
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    decoding="async"
    className={`logo-mark ${className}`}
    style={{ width: size, height: size }}
    data-testid={testId}
  />
);

export const LogoLockup = ({ size = 44, subtitle = true, className = "", priority = false, testId = "brand-lockup", ...rest }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid={testId} {...rest}>
    <Logo size={size} priority={priority} testId={`${testId}-logo`} />
    <div className="leading-none">
      <div className="font-display font-black tracking-tight text-[1.15rem] sm:text-[1.3rem] text-white">
        KING<span className="text-neon glow-green">BULLISH</span>
      </div>
      {subtitle && (
        <div className="mt-1 font-body font-semibold text-[0.6rem] tracking-[0.3em] text-neon/90">
          INVEST IN THE FUTURE
        </div>
      )}
    </div>
  </div>
);
